export default "__VITE_ASSET__b22f95bd__"